<template>
  <div class="customers-item">
    <router-link
      :to="url"
      class="customers-item-content"
    >
      <ul class="customers-item-details">
        <li
          v-if="guarantor"
          class="customers-item-detail"
        >
          <b>{{ customer && customer.name | namelize }}</b>
        </li>

        <li
          v-if="email"
          class="customers-item-detail"
        >
          {{ email }}
        </li>

        <li
          v-if="phones"
          class="customers-item-detail"
        >
          {{ phones }}
        </li>
      </ul>

      <former-button
        v-if="guarantor"
        color="red"
        size="smaller"
        icon="trash"
        iconed
        @click.native.prevent.capture="toggle"
      />
    </router-link>

    <popup-confirm
      v-if="removing"
      color="red"
      title="Remover avalista"
      :loading="loading"
      @close="toggle"
      @confirm="destroy"
    >
      Você tem certeza?
    </popup-confirm>
  </div>
</template>

<script>
  import { PHONE_FORMAT } from '@cordel/helpers/form/validators/phone';
  import { CELLPHONE_FORMAT } from '@cordel/helpers/form/validators/cellphone';

  import patternize from '@sdk/helpers/formatters/patternize';

  import domains from '@/helpers/apis/domains';
  // eslint-disable-next-line import/no-extraneous-dependencies
  import PopupConfirm from '@/components/Popup/Confirm.vue';
    // eslint-disable-next-line import/no-extraneous-dependencies
  import FormerButton from '@/components/Former/Button.vue';

  export default {
    name: 'CustomerListItem',
    components: {
      FormerButton,
      PopupConfirm,
    },
    props: {
      customer: {
        type: Object,
        default() {
          return {};
        },
      },
      loading: {
        type: Boolean,
        default: false,
      },
      guarantor: {
        type: Boolean,
        default: false,
      },
    },
    data() {
      return {
        removing: false,
      };
    },
    computed: {
      phones() {
        const {
          CELULAR,
          PRINCIPAL,
        } = domains.phone_types;

        const phones = (this.customer.phones || [])
          .filter(phone => phone.phone_type && [CELULAR, PRINCIPAL]
            .indexOf(phone.phone_type.name) > -1)
          .splice(0, 2)
          .map(phone => patternize(`${phone.code}${phone.number}`, {
            format: PHONE_FORMAT,
            bigFormat: CELLPHONE_FORMAT,
          }));

        return phones.length ? phones.join(' | ') : null;
      },
      email() {
        const {
          emails,
        } = this.customer;

        if (emails && emails.length && emails[0].address) {
          return emails[0].address.toLowerCase();
        }

        return null;
      },
      url() {
        return {
          name: 'customers-read-informations',
          params: {
            id: this.customer.id,
          },
        };
      },
    },
    methods: {
      toggle() {
        this.removing = !this.removing;
      },
      destroy() {
        this.$emit('destroy', this.customer.id);
      },
    },
  };
</script>

<style lang="scss" scoped>
  @import '@/assets/stylesheets/_variables.scss';

  .customers-item-content {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .customers-item-details {
    list-style: none;
  }

  .customers-item-detail {
    margin-top: $gutter-smaller;

    &:first-child {
      margin-top: 0;
    }
  }
</style>
